<form [formGroup]="form">
  <button
    class="text-components-content-neutral-secondary component-small-medium mb-md pl-0 underline"
    hlmBtn
    variant="link"
    type="reset"
  >
    Réinitialiser les filtres
  </button>
  <div hlmFieldGroup>
    <div hlmField>
      <label hlmFieldLabel for="select-cartographies">Cartographies</label>
      <hlm-select id="select-cartographies" formControlName="cartographies" multiple>
        <hlm-select-trigger>
          <hlm-select-value />
        </hlm-select-trigger>

        <hlm-select-content>
          @for (cartographie of cartographies() | trierPar: 'nom'; track cartographie.id) {
            <hlm-option [value]="cartographie.slug">
              {{ cartographie.nom }}
            </hlm-option>
          }
        </hlm-select-content>
      </hlm-select>
    </div>

    <div hlmField>
      <label hlmFieldLabel for="select-services">Services</label>
      <hlm-select id="select-services" formControlName="services" multiple>
        <hlm-select-trigger>
          <hlm-select-value />
        </hlm-select-trigger>

        <hlm-select-content>
          @for (type of referentielTypes | keyvalue; track type.key) {
            <hlm-option [value]="type.value">{{ type.value | convertReferentielTypeToString }}</hlm-option>
          }
        </hlm-select-content>
      </hlm-select>
    </div>

    @if (estMetierSelectionne) {
      <div hlmField>
        <label hlmFieldLabel for="select-instituts-metiers">Instituts métiers</label>
        <hlm-select id="select-instituts-metiers" formControlName="institutsMetiers" multiple>
          <hlm-select-trigger>
            <hlm-select-value />
          </hlm-select-trigger>

          <hlm-select-content>
            @for (im of institutsMetier | keyvalue; track im) {
              <hlm-option [value]="im.key">{{ im.key }} - {{ im.value }}</hlm-option>
            }
          </hlm-select-content>
        </hlm-select>
      </div>
    }

    <div hlmField>
      <label hlmFieldLabel for="select-livrables">Livrables</label>
      <hlm-select id="select-livrables" formControlName="livrables" multiple>
        <hlm-select-trigger>
          <hlm-select-value />
        </hlm-select-trigger>

        <hlm-select-content>
          @for (livrablePrincipal of livrablesPrincipaux | keyvalue: null; track livrablePrincipal.key) {
            <hlm-option [value]="livrablePrincipal.value">{{ livrablePrincipal.value }}</hlm-option>
          }
        </hlm-select-content>
      </hlm-select>
    </div>

    <div hlmField>
      <label hlmFieldLabel for="select-statuts">Statuts</label>
      <hlm-select id="select-statuts" formControlName="statuts" multiple>
        <hlm-select-trigger>
          <hlm-select-value />
        </hlm-select-trigger>

        <hlm-select-content>
          @for (etat of etats | keyvalue: null; track etat.key) {
            <hlm-option [value]="etat.key">{{ etat.value }}</hlm-option>
          }
        </hlm-select-content>
      </hlm-select>
    </div>

    <div hlmField>
      <label hlmFieldLabel for="select-echeance">Échéance</label>
      <hlm-select id="select-echeance" formControlName="echeance">
        <hlm-select-trigger>
          <hlm-select-value />
        </hlm-select-trigger>

        <hlm-select-content>
          <hlm-option value="ONE_WEEK">Dans une semaine</hlm-option>
          <hlm-option value="ONE_MONTH">Dans un mois</hlm-option>
          <hlm-option value="THREE_MONTHS">Dans trois mois</hlm-option>
        </hlm-select-content>
      </hlm-select>
    </div>
  </div>
</form>
